export const FooterText = ({
  supportText = "",
  termsText = "",
  lastUpdated = "",
}) => {
  return (
    <div className="card shadow-sm p-4 mb-4 small">
      {supportText && <p className="mb-3 text-muted">{supportText}</p>}

      <div
        className="p-3 rounded"
        style={{
          backgroundColor: "#f7fee7",
          border: "1px solid #ecfccb",
        }}
      >
        {lastUpdated && <em>Last updated: {lastUpdated}</em>}
        <p
          className="mb-0"
          style={{ fontSize: "13px", color: "#65a30d", lineHeight: "1.5" }}
        >
          {termsText}
        </p>
      </div>
    </div>
  );
};
